import { Layout, Typography, Card, Button, Form } from 'antd';
import React from "react";
import logoImage from "../images/logo-black.png";
import "../importData/Homepage.css";

import { useNavigate } from "react-router-dom";

export default function Support() {
  const navigate = useNavigate();

  return (
    <>
      <main className="min-h-screen newHomeContainer">
        <div className='innerHeader'>
            <div className="landHeader">
            <div className="container px-4">
                <div className="logoWraps">
                <span className="txtLogo font-bold" onClick={() => navigate("/home")} >Ezwinds</span>
                </div>

                <div className="btnWraps">
                <Button
                    size="lg"
                    variant="hero"
                    className="text-base logBtns"
                    onClick={() => navigate("/login")}
                >
                    Log In{" "}
                    <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-arrow-right ml-2 h-5 w-5"
                    >
                    <path d="M5 12h14"></path>
                    <path d="m12 5 7 7-7 7"></path>
                    </svg>
                </Button>

                <Button
                    size="lg"
                    variant="heroOutline"
                    className="text-base logBtns ml_space"
                    onClick={() => navigate("/register")}
                >
                    Register{" "}
                    <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-arrow-right ml-2 h-5 w-5"
                    >
                    <path d="M5 12h14"></path>
                    <path d="m12 5 7 7-7 7"></path>
                    </svg>
                </Button>
                </div>
            </div>
            </div>
            <div className="absolute inset-0 bg-hero-gradient"></div>
        </div>
        {/* Header End */}

        <section className="py-20 bg-secondary/30 relative overflow-hidden bgBlues" style={{ minHeight: '600px'}}>
            <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_50%,rgba(59,130,246,0.05),transparent_50%)]"></div>

            <div className="container px-4 relative z-10">
                <div className="text-center max-w-3xl mx-auto mb-16 animate-fade-in">
                    <h1 className="text-4xl md:text-5xl lg:text-5xl font-bold text-foreground mb-4">
                        Support & Info
                    </h1>
                    <p className="text-lg text-muted-foreground">
                        We're here to help you get the most out of your digital signage. Browse our support resources below.
                    </p>
                </div>

                <div className="relative animate-fade-in-up">
                    <div className="relative grid md:grid-cols-2 lg:grid-cols-2 gap-8">
                        {/* 01 */}
                        <div className="relative bg-card rounded-2xl p-6 border border-border hover:border-primary/50 transition-all duration-300 group h-full">
                            <div className="absolute -top-4 -right-4 w-12 h-12 rounded-full bg-accent-gradient text-accent-foreground font-bold text-lg flex items-center justify-center shadow-lg">
                                01
                            </div>
                            <div className="mb-4 inline-flex p-3 rounded-xl bg-primary/10 group-hover:scale-110 transition-transform duration-300">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-rocket h-8 w-8 text-primary">
                                    <path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z"></path>
                                    <path d="m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z"></path>
                                    <path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0"></path>
                                    <path d="M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5"></path>
                                </svg>
                            </div>
                            <h3 className="text-xl font-semibold mb-3 text-card-foreground">
                                Getting Started
                            </h3>
                            <p className="text-muted-foreground mb-2">
                                New to Ezwinds? Getting your digital signage up and running is fast and straightforward. Follow our easy setup guides to connect your devices and start creating beautiful campaigns right away.
                            </p>
                            <p className="text-muted-foreground">
                                If you have any questions during the onboarding process, reach out to our dedicated support team.
                            </p>
                        </div>
                        
                        {/* 02 */}
                        <div className="relative bg-card rounded-2xl p-6 border border-border hover:border-primary/50 transition-all duration-300 group h-full">
                            <div className="absolute -top-4 -right-4 w-12 h-12 rounded-full bg-accent-gradient text-accent-foreground font-bold text-lg flex items-center justify-center shadow-lg">
                                02
                            </div>
                            <div className="mb-4 inline-flex p-3 rounded-xl bg-primary/10 group-hover:scale-110 transition-transform duration-300">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-user-cog h-8 w-8 text-primary">
                                    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
                                    <circle cx="9" cy="7" r="4"></circle>
                                    <circle cx="19" cy="11" r="2"></circle>
                                    <path d="M19 8v1"></path>
                                    <path d="M19 13v1"></path>
                                    <path d="m21.6 9.5-.87.5"></path>
                                    <path d="m17.27 12-.87.5"></path>
                                    <path d="m21.6 12.5-.87-.5"></path>
                                    <path d="m17.27 10-.87-.5"></path>
                                </svg>
                            </div>
                            <h3 className="text-xl font-semibold mb-3 text-card-foreground">
                                Account Issues
                            </h3>
                            <p className="text-muted-foreground mb-2">
                                Trouble logging in? If you've forgotten your password, select "Forgot Password" on the login screen, and we will send you a reset link via email.
                            </p>
                            <p className="text-muted-foreground">
                                Make sure that you are using the correct merchant email or phone number associated with your Ezwinds account.
                            </p>
                        </div>

                        {/* 03 */}
                        <div className="relative bg-card rounded-2xl p-6 border border-border hover:border-primary/50 transition-all duration-300 group h-full">
                            <div className="absolute -top-4 -right-4 w-12 h-12 rounded-full bg-accent-gradient text-accent-foreground font-bold text-lg flex items-center justify-center shadow-lg">
                                03
                            </div>
                            <div className="mb-4 inline-flex p-3 rounded-xl bg-primary/10 group-hover:scale-110 transition-transform duration-300">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-wrench h-8 w-8 text-primary">
                                    <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"></path>
                                </svg>
                            </div>
                            <h3 className="text-xl font-semibold mb-3 text-card-foreground">
                                Technical Support
                            </h3>
                            <p className="text-muted-foreground mb-2">
                                Encountering display glitches or connectivity issues? Our technical support team operates around the clock to ensure your screens stay active. Check your network connection first, and if the issue persists, let us know immediately.
                            </p>
                        </div>

                        {/* 04 */}
                        <div className="relative bg-card rounded-2xl p-6 border border-border hover:border-primary/50 transition-all duration-300 group h-full">
                            <div className="absolute -top-4 -right-4 w-12 h-12 rounded-full bg-accent-gradient text-accent-foreground font-bold text-lg flex items-center justify-center shadow-lg">
                                04
                            </div>
                            <div className="mb-4 inline-flex p-3 rounded-xl bg-primary/10 group-hover:scale-110 transition-transform duration-300">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-credit-card h-8 w-8 text-primary">
                                    <rect width="20" height="14" x="2" y="5" rx="2"></rect>
                                    <line x1="2" x2="22" y1="10" y2="10"></line>
                                </svg>
                            </div>
                            <h3 className="text-xl font-semibold mb-3 text-card-foreground">
                                Billing & Pricing
                            </h3>
                            <p className="text-muted-foreground mb-2">
                                For any questions related to subscriptions, charges, or invoicing, our billing department is ready to assist. You can seamlessly upgrade or adjust your plan via the dashboard settings.
                            </p>
                        </div>
                    </div>
                </div>

            </div>
        </section>

        {/* FOOTER Start*/}
        <footer className="bg-card border-t border-border pt-4">
        <div className="container px-4 pt-5 py-2 md:py-16">
            <div className="ftrGrid grid md:grid-cols-2 lg:grid-cols-6 gap-8 lg:gap-12">
            {/* Brand Column */}
            <div className="lg:col-span-2 logoParts">
                <div className="flex items-center gap-2 mb-3">
                <img 
                    src={logoImage} 
                    alt="logo" 
                    className="logoImg"
                    /> 
                </div>
                <p>
                Transform your retail space with powerful digital advertising solutions that engage customers and drive sales
                </p>

                <div className="space-y-3">
                <div className="flex items-center gap-2 text-sm text-muted-foreground">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-mail h-4 w-4"><rect width="20" height="16" x="2" y="4" rx="2"></rect><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"></path></svg>
                    <span><a href='mailto:info@ezwinds.com'>info@ezwinds.com</a></span>
                </div>
                <div className="flex items-center gap-2 text-sm text-muted-foreground">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-phone h-4 w-4"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>
                    <span><a href='tel:+12073705346'>+1 207 370 5346</a></span>
                </div>
                <div className="flex items-center gap-2 text-sm text-muted-foreground">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-map-pin h-4 w-4"><path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"></path><circle cx="12" cy="10" r="3"></circle></svg>
                    <span>New York, US</span>
                </div>
                </div>
                
            </div>

            {/* Links Columns */}
            <div className='ftrLinks'>
                <h3 className="ftTitles">Product</h3>
                <ul className="space-y-2">             
                <li>
                    <a className="text-muted-foreground hover:text-primary transition-colors text-sm">
                    Features
                    </a>
                </li>
                <li>
                    <a className="text-muted-foreground hover:text-primary transition-colors text-sm">
                    Pricing
                    </a>
                </li>
                <li>
                    <a className="text-muted-foreground hover:text-primary transition-colors text-sm">
                    FAQ
                    </a>
                </li>
                <li>
                    <a className="text-muted-foreground hover:text-primary transition-colors text-sm">
                    Demo
                    </a>
                </li>
                </ul>
            </div>

            {/* Links Columns */}
            <div className='ftrLinks'>
                <h3 className="ftTitles">Company</h3>
                <ul className="space-y-2">             
                <li>
                    <a className="text-muted-foreground hover:text-primary transition-colors text-sm">
                    About Us
                    </a>
                </li>
                <li>
                    <a className="text-muted-foreground hover:text-primary transition-colors text-sm">
                    Careers
                    </a>
                </li>
                <li>
                    <a className="text-muted-foreground hover:text-primary transition-colors text-sm">
                    Blog
                    </a>
                </li>
                <li>
                    <a className="text-muted-foreground hover:text-primary transition-colors text-sm">
                    Press Kit
                    </a>
                </li>
                </ul>
            </div>

            {/* Links Columns */}
            <div className='ftrLinks'>
                <h3 className="ftTitles">Resources</h3>
                <ul className="space-y-2">             
                <li>
                    <a className="text-muted-foreground hover:text-primary transition-colors text-sm">
                    Documentation
                    </a>
                </li>
                <li>
                    <a className="text-muted-foreground hover:text-primary transition-colors text-sm">
                    API Reference
                    </a>
                </li>
                <li>
                    <a href="/support" className="text-muted-foreground hover:text-primary transition-colors text-sm">
                    Support
                    </a>
                </li>
                <li>
                    <a className="text-muted-foreground hover:text-primary transition-colors text-sm">
                    Contact
                    </a>
                </li>
                </ul>
            </div>

            {/* Links Columns */}
            <div className='ftrLinks'>
                <h3 className="ftTitles">Legal</h3>
                <ul className="space-y-2">             
                <li>
                    <a href='/privacy-policy' className="text-muted-foreground hover:text-primary transition-colors text-sm">
                    Privacy Policy
                    </a>
                </li>
                <li>
                    <a href='/copyright-policy' className="text-muted-foreground hover:text-primary transition-colors text-sm">
                    Copyright Policy
                    </a>
                </li>
                <li>
                    <a className="text-muted-foreground hover:text-primary transition-colors text-sm">
                    Terms of Service
                    </a>
                </li>
                <li>
                    <a className="text-muted-foreground hover:text-primary transition-colors text-sm">
                    Cookie Policy
                    </a>
                </li>
                <li>
                    <a className="text-muted-foreground hover:text-primary transition-colors text-sm">
                    GDPR
                    </a>
                </li>
                </ul>
            </div>
        
            </div>
            
            <div className="border-t border-border mt-4 py-4">
            <div className="flex flex-col md:flex-row justify-between items-center gap-4 ftrCopyright">
                <p className="text-sm text-muted-foreground my-1">
                © 2025 Ezwinds. All rights reserved.
                </p>
                <div className="flex items-center gap-6 socilIcons">
                <a href="#" className="text-muted-foreground hover:text-primary transition-colors">
                    <span className="sr-only">Twitter</span>
                    <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                    <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" />
                    </svg>
                </a>
                <a href="#" className="text-muted-foreground hover:text-primary transition-colors">
                    <span className="sr-only">LinkedIn</span>
                    <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                    <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
                    </svg>
                </a>
                </div>
            </div>
            </div>
        </div>
        </footer>

        {/* FOOTER End*/}
    </main>

    </>
  );
}
